module.exports = __webpack_public_path__ + "img/ty.b74f8649.png";